var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"form"},[(!_vm.loading)?_c('form',{attrs:{"id":_vm.fieldId}},[_vm._l((_vm.fields),function(field){return [_c('componentRenderer',{key:field.id,class:`col-lg-${field.properties.grid.columns}`,staticStyle:{"margin-top":"20px"},attrs:{"field":field},on:{"component-updated":_vm.updated}})]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }